import React from 'react'
import { Typography, Grid, Select, MenuItem, InputLabel, FormControl } from '@mui/material'
import { FetchQuickBillDetailsQuery } from '../../../../generated'
import { CardBox, CardBoxTopBar } from '../../../theme/styleComponents'

interface GeneralSectionProps {
  litigation: FetchQuickBillDetailsQuery['fetchQuickBillDetails']['case'] | undefined
}

const GeneralSection: React.FC<GeneralSectionProps> = ({ litigation }) => {
  return (
    <CardBox my={3}>
      <CardBoxTopBar>
        <Typography variant="h6" fontWeight={400} color="gray900" fontSize="18px">
          General
        </Typography>
      </CardBoxTopBar>

      <Grid container spacing={2} p={3}>
        <Grid item xs={12}>
          <FormControl fullWidth disabled>
            <InputLabel id="matter-title">Matter</InputLabel>
            <Select labelId="matter-title" label="Matter" value={litigation?.title || ''}>
              <MenuItem value={litigation?.title || ''}>{litigation?.title || ''}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </CardBox>
  )
}

export default GeneralSection
